import { getEnvironmentConfig } from './config/environment';

// 載入環境配置
const config = getEnvironmentConfig();

// 環境相關配置 (動態載入)
export const API_URL = config.apiUrl;
export const LINE_LOGIN_URI = config.lineLoginUri;
export const LINE_LOGIN_CLIENT_ID = config.lineLoginClientId;
export const LINE_REDIRECT_URL = config.lineRedirectUrl;
export const LINE_CHANNEL_ID = config.lineChannelId;
export const LINE_REDIRECT_URI = config.lineRedirectUri;
export const LINE_CHANNEL_SECRET = config.lineChannelSecret;
export const LIFF_ID = config.liffId;

// 應用程式常數 (不變)
export const USER_INFO_KEY = 'user-info';
export const IS_USER_LOGIN = 'is-user-login';
export const YJ_ACCESS_TOKEN = 'yj-access-token'; // 永靖的 token
export const IS_MOBILE_LOGIN = 'is-mobile-login';
export const ORIGINAL_URL = '/mobile';
export const COOKIE_NAME = 'lineLoginStatus';
export const COOKIE_GET_LINETOKEN_NAME = 'lineGetToken';
export const COOKIE_LOGUT_NAME = 'lineLogout';

// 位置精確度設定
export const LOCATION_ACCURACY_CONFIG = {
  TARGET_ACCURACY: 50,      // 目標精確度（公尺）- GPS 級別精確度
  ACCEPTABLE_ACCURACY: 500, // 可接受精確度（公尺）- 網路定位級別
  MAX_RETRIES: 2,          // 最大重試次數 - 減少為2次
  RETRY_DELAY: 200,        // 重試間隔（毫秒）- 大幅縮短
  MAP_MAX_RETRIES: 2,      // 地圖元件最大重試次數
  GEOCODING_MAX_RETRIES: 2, // 地理編碼最大重試次數
  GEOCODING_RETRY_DELAY: 200, // 地理編碼重試間隔
  HIGH_ACCURACY_TIMEOUT: 1000, // 高精確度定位超時時間 - 1.2秒
  FAST_LOCATION_TIMEOUT: 1000, // 快速定位超時時間 - 1秒
  TOTAL_LOCATION_TIMEOUT: 2000 // 總定位時間限制 - 3秒
};
